/**
 * /performance/reviews — Inbox → Reviews: the reviews the person must
 * write, across every open cycle (GET /performance/reviews-owed, scoped
 * to reviewer = caller). Each row opens the cycle to write it.
 *
 * HR runs cycles from Manage → Performance (/performance/cycles); the
 * cycle list, New cycle and Export no longer sit in the Inbox.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { ReviewsQueue } from "@/components/inbox/approval-queues";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/performance/reviews/")({
  component: PerformanceReviewsRoute,
});

function PerformanceReviewsRoute() {
  return (
    <PerformanceModuleShell
      title="Reviews"
      description="Reviews waiting for you to write, in every open review cycle."
    >
      <PerformanceFeatureGate>
        <ReviewsQueue />
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
